<label for="row-selector-{{ id }}" class="sr-only">Select row</label>
<input type="radio" id="row-selector-{{ id }}" name="single-row-selector" class="column-row-selector" value="{{ value }}" data-model-cid="{{ id }}"/>